import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { IconButton } from '@mui/material';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
ReactSession.setStoreType("localStorage");





const ProductList = () => {
   const navigate = useNavigate();
  const userId=ReactSession.get("welbeingId");
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10; // items per page
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");


  if(userId  <= 0 ){
      navigate('/login');
   }
  


  console.log(products)




 const handlePageChange = (event, value) => {
    setPage(value);
  };
  const fetchProducts = () => {
    axios
      .get(`https://api.welbeing.in/admin/products/get-products/?page=${page}&limit=${limit}&search=${search}`)
      .then((response) => {
        setProducts(response.data.data || []);
        setTotal(response.data.total);
        console.log(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  };


  useEffect(()=>{
fetchProducts();
  }, [page, search])



 const handleToggle = async (id, currentValue) => {
  const value = currentValue === 'yes' ? 'no' : 'yes';
  const p_id =parseInt(id);

  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/update-preorder/', {
      p_id: p_id,
      preOrder: value
    });

    console.log(response.data);
    fetchProducts();

  

  } catch (error) {
    console.error("Error updating preorder status:", error);
  }
};



  const handleDelete = async(id,currentValue) => {
  const value = currentValue === '0' ? '1' : '0';
  const p_id =parseInt(id);

  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/delete-product/', {
      p_id: p_id,
      delete: value
    });

    console.log(response.data);
    fetchProducts();

  

  } catch (error) {
    console.error("Error updating preorder status:", error);
  }
  };

  const handleVisibility = async(id,currentValue) => {
  const value = parseInt(currentValue === '0' ? '1' : '0');
  console.log("value",value);
  const p_id =parseInt(id);

  try {
    const response = await axios.post('https://api.welbeing.in/admin/products/update-visibility/', {
      p_id: p_id,
      visibility: value
    });

    fetchProducts();

  

  } catch (error) {
    console.error("Error updating preorder status:", error);
  }
  };

  const totalPages = Math.ceil(total / limit);




   // Copy
      const handleCopy = () => {
        const text = products.map(products =>
          `${products.item_name}\t${products.cat_name}\t${products.subcat_name}\t${products.item_price}\t${products.stock}\t${products.preOrder}`
        ).join('\n');
    
        navigator.clipboard.writeText(text)
          .then(() => alert('Copied to clipboard!'))
          .catch(() => alert('Copy failed!'));
      };
    
      // CSV
      const handleExportCSV = () => {
        const csvRows = [
          ["S.NO", "Products", "Category", "Subcategory ID", "price ", "Stock", "Preorder"],
          ...products.map((products, index) => [index + 1, products.name,
            index + 1,
          products.item_name,
          products.cat_name,
          products.subcat_name,
          products.item_price,
          products.stock,
          products.preOrder,])
        ];
    
        const csvContent = csvRows.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "productsWelbeing.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    
    
      // Pdf
      const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text("Orders Report", 14, 10);
    
        const tableColumn =  ["S.NO", "Products", "Category", "Subcategory", "price ", "Stock", "Preorder"];
        const tableRows = products.map((products, index) => [
          index + 1,
          products.item_name,
          products.cat_name,
          products.subcat_name,
          products.item_price,
          products.stock,
          products.preOrder,
        ]);
    
        autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY: 20,
        });
    
        doc.save("productsWelbeing.pdf");
      };
    
      // Print
    
      const handlePrint = () => {
        const printContent = document.getElementById("productTable").outerHTML;
        const win = window.open('', '', 'height=600,width=800');
        win.document.write('<html><head><title>Print Orders</title></head><body>');
        win.document.write(printContent);
        win.document.write('</body></html>');
        win.document.close();
        win.print();
      };
    
      // Excel
      const handleExportExcel = () => {
        const ws = XLSX.utils.json_to_sheet(products);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "products");
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), "productsWelbeing.xlsx");
      };

  return (
   <>
      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div className="container-fluid">
            {/* Header Section */}
            <div className="card bg-light-info shadow-none position-relative overflow-hidden">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  {/* Left Side: Title + Breadcrumb */}
                  <div className="col-md-9 col-12 mb-3 mb-md-0">
                    <h4 className="fw-semibold mb-2">All Products</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/dashboard" className="text-muted">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Products</li>
                      </ol>
                    </nav>
                  </div>

                  {/* Right Side: Button + Image */}
                  <div className="col-md-3 col-12 text-md-end text-center">
                    <Link to="/add-product" className="btn btn-warning mb-2">Add Product</Link>
                    <div>
                      <img
                        src="dist/images/breadcrumb/ChatBc.png"
                        alt="Breadcrumb"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* Table Section */}
            <section className="mt-3">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="mb-0">File Export</h5>
                       <div className="d-flex flex-wrap gap-2 mb-3 justify-content-between justify-content-md-start mt-3">
                          <button className="btn btn-md btn-primary flex-fill flex-md-grow-0" onClick={handleCopy}>Copy</button>
                          <button className="btn btn-md btn-primary flex-fill flex-md-grow-0" onClick={handleExportCSV}>CSV</button>
                          <button className="btn btn-md btn-primary flex-fill flex-md-grow-0" onClick={handleExportExcel}>Excel</button>
                          <button className="btn btn-md btn-primary flex-fill flex-md-grow-0" onClick={handleExportPDF}>PDF</button>
                          <button className="btn btn-md btn-primary flex-fill flex-md-grow-0" onClick={handlePrint}>Print</button>
                        </div>
                      <div className="d-flex justify-content-end my-3">
                        <div className="w-sm-100 w-lg-25">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search by item code or name..."
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                              setPage(1);
                            }}
                          />
                        </div>
                      </div>


                      <div className="table-responsive" style={{ overflowX: "auto" }}>
                        <table id="productTable" className="table table-bordered table-striped table-hover text-nowrap mt-3">

                          <thead className="table-light">
                            <tr>
                              <th>Product</th>
                              <th>Category</th>
                              <th>Sub Category</th>
                              <th>Price</th>
                              <th>Stock</th>
                              <th>Pre Order</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {products?.length > 0 ? (
                              products.map((product) => (
                                <tr key={product.id}>
                                  <td className="d-flex align-items-center">
                                    <img
                                     src={`https://api.welbeing.in/uploads/products/${product.img1}`}
                                      alt={product.name}
                                      width="40"
                                      height="40"
                                      className="rounded-circle me-2"
                                    />
                                    <div>
                                      <h6 className="mb-0">{product.item_name}</h6>
                                      <small>{product.item_code}</small><br />
                                      <small>{product.p_id}</small>
                                    </div>
                                  </td>
                                  <td>{product.cat_name}</td>
                                  <td>{product.subcat_name}</td>
                                  <td>₹{parseFloat(product.item_price).toFixed(2)}</td>
                                  <td>{product.stock}</td>
                                  <td>
                                    <IconButton
                                      onClick={() => handleToggle(product.p_id, product.preOrder)}
                                      sx={{ color: product.preOrder === 'yes' ? '#4caf50' : '#f44336' }}
                                    >
                                      {product.preOrder === 'yes' ? (
                                        <ToggleOnIcon sx={{ fontSize: 35 }} />
                                      ) : (
                                        <ToggleOffIcon sx={{ fontSize: 35 }} />
                                      )}
                                    </IconButton>

                                  </td>
                                  <td>
                                    <div className="btn-group">
                                      {/* Visibility toggle */}
                                      {product.visibility === "0" ? (
                                        <button
                                          className="btn btn-success"
                                          onClick={() => handleVisibility(product.p_id, product.visibility)}
                                        >
                                          <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer' }} className="ti ti-eye" />
                                        </button>
                                      ) : (
                                        <button
                                          className="btn btn-danger"
                                          onClick={() => handleVisibility(product.p_id, product.visibility)}
                                        >
                                          <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer' }} className="ti ti-eye-off" />

                                        </button>
                                      )}

                                      {/* Edit Button */}
                                      <Link to={`/edit-product?id=${product.p_id}`} className="btn btn-primary">
                                        <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer' }} className="ti ti-edit" />

                                      </Link>

                                      {/* Delete Button */}
                                      <button
                                        onClick={() => handleDelete(product.p_id, product.delete)}
                                        className="btn btn-danger"
                                      >
                                        <i style={{ color: '#fff', fontSize: '1rem', transition: 'all 0.3s ease', cursor: 'pointer' }} className="ti ti-trash" />

                                      </button>
                                    </div>
                                  </td>

                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center text-muted">No products found.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* pagination */}
                      <div className="row">
                        <div className="col-12">
                          <nav>
                            <ul className="pagination justify-content-center justify-content-md-end flex-wrap gap-2">

                              {/* Previous Button */}
                              <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={(e) => handlePageChange(e, page - 1)}>
                                  « Previous
                                </button>
                              </li>

                              {/* Page Numbers */}
                              {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => Math.abs(page - p) <= 2)
                                .map(p => (
                                  <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                    <button className="page-link" onClick={(e) => handlePageChange(e, p)}>
                                      {p}
                                    </button>
                                  </li>
                                ))}

                              {/* Ellipsis and Last Page */}
                              {page < totalPages - 2 && (
                                <>
                                  <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                  </li>
                                  <li className="page-item">
                                    <button className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>
                                      {totalPages}
                                    </button>
                                  </li>
                                </>
                              )}

                              {/* Next Button */}
                              <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={(e) => handlePageChange(e, page + 1)}>
                                  Next »
                                </button>
                              </li>

                            </ul>
                          </nav>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductList;
 
